var getData = R.prop('data');

const baseURL = '/strategies';

const fetchAll = () =>
    axios.get(`${baseURL}`).then(R.path(['data', 'strategies']));

const apply = ({ action, userInputs, proposalRequestMeta } = {}) => {
    return axios
        .post(`${baseURL}/applyAction`, {
            action,
            userInputs,
            proposalRequestMeta,
        })
        .then(getData);
};

export default { fetchAll, apply };
